<template>
    <label>{{autoValue[json.showkey]}}</label>
</template>
<script>
    /**
     * 输入框搜索组件，与auto-search不同的是，绑定的值是指定的一个字断，不是一个对象
     * @author zjs
     * @time 2018-03-21
     */
    export default {
        name: 'LyAutoText',
        props: {
        	value: {
            	type: [Object, String, Number],
            	default: ''
        	},
            /**
             {
                api 接口请求地址
                showkey 返回数据中用于显示的字段
             }
             */
            json: Object,   
            watchField: { // 监听变化的值，也作为搜索的参数
                type: [String, Number, Object]
            },
            watchFieldTwo: { // 监听变化的值，也作为搜索的参数
                type: [String, Number, Object]
            }
        },
        data () {
            return {
                autoValue: '',
                queryField: {}
            }
        },
        watch: {
            /**
             * 搜索关联字段，值变化的监听
             * @param  {[type]} v [description]
             * @return {[type]}   [description]
             */
            watchField (v) {
                if (v) {
                    // 2022-1-13 welpher 把值传到queryField
                    if (typeof v === 'object') {
                        Object.keys(v).forEach((key) => {
                            this.queryField[key] = v[key]
                        })
                    } else {
                        this.queryField[this.json.watch] = v
                    }
                    if (this.watchFieldTwo) {
                        this.queryField[this.json.watch2] = this.watchFieldTwo
                    }
            		this.querySearchAsync()
                }
            },
            watchFieldTwo (v) {
                if (v) {
                    // 2022-1-13 welpher 把值传到queryField
                    if (typeof v === 'object') {
                        Object.keys(v).forEach((key) => {
                            this.queryField[key] = v[key]
                        })
                    } else {
                        this.queryField[this.json.watch2] = v
                    }
                    if (this.watchField) {
                        this.queryField[this.json.watch] = v
                    }
                    this.querySearchAsync()
                }
            }
        },
        created () {
            if (this.watchField) {
                if (this.watchFieldTwo) {
                    this.watchField['weidu_id'] = this.watchFieldTwo
                }
                this.querySearchAsync()
            }
        },
        methods: {
            /**
             * 数据的读取
             * @return {[type]} [description]
             */
            querySearchAsync () { 
	            this.timer && clearTimeout(this.timer)
	            this.timer = setTimeout(() => {
	                this.$api.create(this.json.api, this.queryField).then((rs) => {
	                    this.autoValue = rs
	                    this.$emit('input', rs)
	                }).catch((err) => {
	                    console.error('auto-text query error:%O', err)
	                })
	            }, 800)
            }
        }
    }
</script>